const MODULE = require('./getDestinationItem');


module.exports.transferQuantity = function({ 
  source, 
  destination,
  destinationKey,
  producerproduct_id, 
  quantity,
  keysToCopy = ['consumer_price','producerproduct_id','quantity','reason','percentage','tva']
}, options, useStrictEquals = false){

  const areIdsEqual = (a,b) => {
    return useStrictEquals
      ? a === b
      : a.equals(b);
  };
  /* make the outputs invariant */
  const newSource = source.map(s => {

    let output = {
      producerproduct_id: s.producerproduct_id,
      quantity: s.quantity,
      consumer_price: s.consumer_price,
      tva: s.tva
    };

    if(typeof s.percentage !== 'undefined'){
      output.percentage = s.percentage;
    }
    if(typeof s.reason !== 'undefined'){
      output.reason = s.reason;
    }
    if(typeof s.real_weight !== 'undefined'){
      output.real_weight = s.real_weight;
    }

    if(
      areIdsEqual(s.producerproduct_id, producerproduct_id)
      && typeof quantity === 'undefined'
    ){
      // ie. quantity === undefined means 'all the quantity'
      quantity = s.quantity;
    }

    return output;
  });
  const newDestination = destination.map(d => {

    let output = {
      producerproduct_id: d.producerproduct_id,
      quantity: d.quantity,
      consumer_price: d.consumer_price,
      tva: d.tva
    };

    if(typeof d.percentage !== 'undefined'){
      output.percentage = d.percentage;
    }
    if(typeof d.reason !== 'undefined'){
      output.reason = d.reason;
    }
    if(typeof d.real_weight !== 'undefined'){
      output.real_weight = d.real_weight;
    }

    return output;
  });

  /* get source and destination indices */
  const newSourceIndex = newSource.findIndex(
    item => areIdsEqual(item.producerproduct_id, producerproduct_id)
  );
  const newDestinationIndex = newDestination.findIndex(
    item => areIdsEqual(item.producerproduct_id, producerproduct_id)
  );

  const newSourceItem = newSource[newSourceIndex];

  if(newSourceItem.quantity == quantity){ // allow for quantity being a string...
    newSource.splice(newSourceIndex, 1);
  }
  else {
    newSource[newSourceIndex].quantity -= quantity;
  }

  if(newDestinationIndex === -1){

    const newDestinationItem = MODULE.getDestinationItem(
      newSourceItem,
      destinationKey,
      Object.assign({ quantity }, options),
      keysToCopy
    );

    newDestination.push(newDestinationItem);
  }
  else {
    newDestination[newDestinationIndex].quantity += quantity;
  }

  return {
    source: newSource,
    destination: newDestination
  };
};